export const FETCH_AUDITTRAIL_REQUEST = "FETCH_AUDITTRAIL_REQUEST";
export const FETCH_AUDITTRAIL_SUCCESS = "FETCH_AUDITTRAIL_SUCCESS";
export const FETCH_AUDITTRAIL_FAILURE = "FETCH_AUDITTRAIL_FAILURE";
